module.exports = __webpack_public_path__ + "static/media/amusement(19).c7a41c28.PNG";